import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LensBuilderType from '../../../../types/lens-builder.type';
import './LensPackage.scss';

import orderSlice, { getCurrentOrder } from '../../../../store/slices/order.slice';
import LensType from '../../../../store/interfaces/lens-package.interface';
import { Button, StepsIndicator } from '../../../../components/ui';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import lensePackage from '../../../../constants/lense-package.constant';

const LensPackage: React.FC<any> = () => {
  const {
    order: { lensType },
  } = useSelector(getCurrentOrder);
  const [lensPackage, setLensPackage] = useState(
    lensType?.lensPackage ? lensType?.lensPackage : lensePackage[0],
  );
  const dispatch = useDispatch();

  const handleChange = (lensPackage: LensType) => {
    setLensPackage(lensPackage);
  };

  const handleContinue = () => {
    if (lensPackage) {
      dispatch(orderSlice.actions.setLensPackage(lensPackage));
    }
  };

  return (
    <div className="vision-wrapper">
      <StepsIndicator count={3} step={2}></StepsIndicator>
      <div className="order-process-view lens">
        <h2 className="header">CHOOSE YOUR LENSES</h2>
        <div className="process-description lens-package">
          <ul>
            {lensePackage.map((l, index) => (
              <li>
                <img src={l.imagePath} className="pres-img" />
                <div className="lens-info-container">
                  <input
                    type="radio"
                    name="lensePackage"
                    value={l.name}
                    defaultChecked={lensPackage?.name === l.name}
                    onChange={() =>
                      handleChange({
                        name: l.name,
                        code: l.code,
                        addOnPrice: l.addOnPrice,
                      })
                    }
                  />
                  <span>{l.name}</span>
                  <OverlayTrigger
                    key="top"
                    placement="top"
                    overlay={<Tooltip id={`tooltip-$top`}>{l.tooltip}</Tooltip>}
                  >
                    <a className="tooltip-btn" title=""></a>
                  </OverlayTrigger>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="cta-container">
        <Button click={() => dispatch(orderSlice.actions.setStep(LensBuilderType.VISION_NEED))}>
          GO BACK TO VISION
        </Button>
        <Button className="button secondary-button" click={handleContinue}>
          Continue
        </Button>
      </div>
    </div>
  );
};

export default LensPackage;
